import { FC, useEffect, useState } from 'react';
import { useField } from 'formik';
import cx from 'classnames';

import ChesedInput from './ChesedInput';

import styles from '../ChallengeForm/ChallengeForm.module.scss';

const ChesedIdeas: FC<{ name: string }> = ({ name }) => {
	const [field, meta, helpers] = useField<string[]>(name);
	const [touched, setTouched] = useState<Map<number, boolean>>();
	const [focused, setFocused] = useState<Map<number, boolean>>();

	const onChangeHandler = (value: string, index: number) => {
		const updatedValues = [...field.value];
		updatedValues[index] = value;
		touched?.set(index, true);
		helpers.setValue(updatedValues);
	};

	const onFocusHandler = (index: number) => {
		focused?.set(index, true);
	};

	const onBlurHandler = (index: number) => {
		focused?.set(index, false);
	};

	const onRemoveHandler = (index: number) => {
		const updatedValues = [...field.value];
		updatedValues.splice(index, 1);

		focused?.delete(index);
		touched?.delete(index);

		helpers.setValue(updatedValues);
	};

	useEffect(() => {
		const touchedInit = new Map();
		const focusedInit = new Map();

		field.value.forEach((v, i) => {
			focusedInit.set(i, false);
			touchedInit.set(i, false);
		});
		setTouched(touchedInit);
		setFocused(focusedInit);
	}, []);

	return (
		<>
			<div className={cx(styles.ChallengeForm__form_item, styles.ChallengeForm__form_item__ideas)}>
				<label className={styles.ChallengeForm__form_label} htmlFor="chesedIdeas">
					Chesed ideas<span className={styles.ChallengeForm__form_required}>*</span>
				</label>

				{field.value?.length ? (
					field.value.map((idea, index) => (
						<div key={index} className={styles.ChallengeForm__form_idea}>
							<ChesedInput
								value={idea}
								placeholder="Idea"
								hideRemoveIcon={!index}
								onChange={value => onChangeHandler(value, index)}
								onFocus={() => onFocusHandler(index)}
								onBlur={() => onBlurHandler(index)}
								focused={focused?.get(index)}
								onRemove={() => onRemoveHandler(index)}
								touched={touched?.get(index)}
								error={meta.error?.[index]}
							/>
						</div>
					))
				) : (
					<div className={styles.ChallengeForm__form_idea}>
						<ChesedInput
							onChange={value => onChangeHandler(value, 0)}
							placeholder="Idea"
							onFocus={() => onFocusHandler(0)}
							onBlur={() => onBlurHandler(0)}
							focused={focused?.get(0)}
							hideRemoveIcon={true}
						/>
					</div>
				)}
			</div>
		</>
	);
};

export default ChesedIdeas;
